//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getContentByCode } from "../../utils/utils";
export default {
  data(){
    return {
      defaultPosition: true,
      currentTotal: {}
    }
  },
  computed: {
    image() {
      const images = this.getImg?.data?.data || []
      return images.length ? images[0]?.picture : ''
    }
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    pictureUrl(url) {
      return this.$absoluteImageUrl(url)
    },
    getText(code) {
      if(this.getTextBlocks?.data?.data) {
        return getContentByCode(this.getTextBlocks.data.data, code)
      } else {
        return ''
      }
    },
    handleScroll() {
      this.defaultPosition = false
      window.removeEventListener('scroll', this.handleScroll, false);
    },
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'podborki-preview',
        auto: true,
        params: {
          code: ['h1-podborki', 'podborki-text'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getImg () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'podborki-preview-img',
        auto: true,
        params: {
          code: ['compilation-picture'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getImagesForGalleryPreview () {
      return {
        url: '/api/v1/fileFromFolder/get',
        key: `getImagesForGalleryPreview`,
        auto: true,
        params: {
          folder: 'virtual-gallery-main-image'
        }
      }
    }
  }
}
